import { useQuery } from '@tanstack/react-query';
import { fetchJobQuestions } from '@worker/services/MyJobs/api';
import { JobQuestion } from '@worker/types/myJobs.type';
import { FIVE_MINUTES, TEN_MINUTES } from '@constants/various';

/**
 * Hook to fetch job questions for a specific job
 * Only fetches when enabled is true (typically when user initiates apply flow)
 */
export function useJobQuestions(jobId: number | undefined, enabled: boolean) {
  return useQuery<JobQuestion[], Error>({
    queryKey: ['jobQuestions', jobId],
    queryFn: () => {
      if (!jobId) throw new Error('Job ID is required');
      return fetchJobQuestions(jobId);
    },
    enabled: enabled && !!jobId,
    staleTime: FIVE_MINUTES,
    gcTime: TEN_MINUTES,
  });
}

export default useJobQuestions;
